import './LoadingPage.css';

import loadingIcon from './../../image/loading-icon.svg';
import loadingLogo from './../../image/logo.svg';

const LoadingPage = () => {
    return (
        <div className='loading__wrapper'>
            <div className='loading__icon'>
                <img src={loadingIcon} alt='Loading' />
            </div>
            <div className='loading__logo'>
                <img src={loadingLogo} alt='Logo' />
            </div>
        </div>
    );
};

export default LoadingPage;
